import SectionHeading from '@/components/base/SectionHeading';
import { testimonials } from '@/mocks/testimonials';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function TestimonialSection() {
  return (
    <section id="voices" className="border-y border-background-200 bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <SectionHeading
          kicker="读者口碑"
          title="他们这样用时间线"
          description="以下评价来自长期关注站内更新的读者，经本人同意后整理发布。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-400" />
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.content}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span
                  className={`flex h-10 w-10 items-center justify-center rounded-full font-heading text-base font-bold ${
                    colorMap[item.color] ?? colorMap.primary
                  }`}
                >
                  {item.name.slice(0, 1)}
                </span>
                <span className="flex flex-col">
                  <span className="font-label text-sm text-foreground-950">{item.name}</span>
                  <span className="font-label text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}